<template>
  <div :class="['lr-modal', {'hide': !insurance.showConfirm}]">
    <div class="lr-box">
      Are you sure you want to upload Report ID: <b>{{ id }}</b>
      <div class="d-flex justify-space-between align-start" style="gap: 20px">
        <a class="button cta secondary block xsmall" @click="cancel">No</a>
        <a class="button cta success block xsmall" @click="upload">Yes</a>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import datepicker from 'vuejs-datepicker'

export default {
  name: 'insurance-create-modal',
  components: { datepicker },
  props: ['id'],
  data () {
    return {
      start: '',
      end: '',
      validation: {
        start: '',
        end: ''
      },
      miles: 0,
      whitelist: ''
    }
  },
  computed: {
    insurance () { return this.$store.state.insurance },
  },
  methods: {
    upload () {
      let self = this
      self.$store.commit('global/setLoaderData', {show: true})
      self.$sdk.post('/insurance/upload', {
        token: self.$store.state.session.sessionToken,
        id: self.id
      }, r => {
        self.$store.commit('global/setLoaderData', {show: false})
        if (r.error) {
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          })
          return
        }
        self.$emit('refreshList')
        self.$store.commit('insurance/setListData', {showConfirm: false})
      }, '2.0')
    },
    cancel () {
      this.$store.commit('insurance/setListData', {showConfirm: false})
    }
  },
  watch: {
    show (x) {
    }
  },
  mounted () {
  }
}
</script>

<style lang="scss" scoped>
.lr-modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.35);
  overflow: auto;
  opacity: 1;
  display: flex;
  justify-content: center!important;
  align-items: center!important;
  -webkit-transition: all 0.2s ease-in;
  -moz-transition: all 0.2s ease-in;
  -o-transition: all 0.2s ease-in;
  transition: all 0.2s ease-in;

  &.hide {
    top: -100%;
    opacity: 0;
  }
}
.lr-box {
  background: #fff;
  padding: 20px;
  border-radius: 6px;
  box-shadow: 3px 3px 2px rgba(0,0,0, .3);
  text-align: center;
  width: 400px;
  line-height: 1;
}

.button{
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/Insurance/ConfirmUpload.vue